// Lazy loaders for heavy libraries - only loaded when needed
export const loadXLSX = () => import("xlsx");
export const loadJsPDF = async () => {
  const mod = await import("jspdf");
  await import("jspdf-autotable");
  return mod;
};
export const loadJSZip = () => import("jszip");
export const loadFileSaver = () => import("file-saver");
export const loadDocx = () => import("docx");
